// Common
import { AssetSchema as rawAssetSchema } from "./common/asset"
import { EmbedSchema as rawEmbedSchema } from "./common/embed"
import { HexaColorCodeSchema as rawHexaColorCodeSchema } from "./common/hexaColorCode"
import { NonEmptyStringSchema as rawNonEmptyStringSchema } from "./common/nonEmptyString"
import { WidgetKeySchema as rawWidgetKeySchema } from "./common/widgetKey"
// Content
import { BooleanContentSchema as rawBooleanContentSchema } from "./content/boolean"
import { DocumentContentSchema as rawDocumentContentSchema } from "./content/document"
import { EmbedContentSchema as rawEmbedContentSchema } from "./content/embed"
import { EmptyContentSchema as rawEmptyContentSchema } from "./content/empty"
import {
	ColorContentSchema as rawColorContentSchema,
	DateContentSchema as rawDateContentSchema,
	NumberContentSchema as rawNumberContentSchema,
	RangeContentSchema as rawRangeContentSchema,
	SelectContentSchema as rawSelectContentSchema,
	TextContentSchema as rawTextContentSchema,
	TimestampContentSchema as rawTimestampContentSchema,
	FieldContentSchema as rawFieldContentSchema,
} from "./content/field"
import { GeoPointContentSchema as rawGeoPointContentSchema } from "./content/geopoint"
import {
	GroupContentSchema as rawGroupContentSchema,
	GroupItemContentSchema as rawGroupItemContentSchema,
} from "./content/group"
import {
	ImageContentSchema as rawImageContentSchema,
	ImageContentViewSchema as rawImageContentViewSchema,
} from "./content/image"
import { IntegrationFieldContentSchema as rawIntegrationFieldContentSchema } from "./content/integrationField"
import {
	EmptyLinkContentSchema as rawEmptyLinkContentSchema,
	FilledLinkContentSchema as rawFilledLinkContentSchema,
	LinkContentSchema as rawLinkContentSchema,
} from "./content/link"
import { NestableContentSchema as rawNestableContentSchema } from "./content/nestable"
import { RepeatableContentSchema as rawRepeatableContentSchema } from "./content/repeatable"
import {
	RichTextContentSchema as rawRichTextContentSchema,
	RichTextContentBlockSchema as rawRichTextContentBlockSchema,
	RichTextContentSpanSchema as rawRichTextContentSpanSchema,
} from "./content/richText"
import { SeparatorContentSchema as rawSeparatorContentSchema } from "./content/separator"
import {
	CompositeSliceContentSchema as rawCompositeSliceContentSchema,
	LegacySliceContentSchema as rawLegacySliceContentSchema,
	SharedSliceContentSchema as rawSharedSliceContentSchema,
	SliceContentSchema as rawSliceContentSchema,
} from "./content/slice"
import {
	LegacySliceItemContentSchema as rawLegacySliceItemContentSchema,
	CompositeSliceItemContentSchema as rawCompositeSliceItemContentSchema,
	SharedSliceItemContentSchema as rawSharedSliceItemContentSchema,
	SliceItemContentSchema as rawSliceItemContentSchema,
	SlicesContentSchema as rawSlicesContentSchema,
} from "./content/slices"
import { TableContentSchema as rawTableContentSchema } from "./content/table"
import { UIDContentSchema as rawUIDContentSchema } from "./content/uid"
import { WidgetContentSchema as rawWidgetContentSchema } from "./content/widget"
// Model
import { BooleanModelSchema as rawBooleanModelSchema } from "./model/boolean"
import { ColorModelSchema as rawColorModelSchema } from "./model/color"
import {
	StaticCustomTypeModelSchema as rawStaticCustomTypeModelSchema,
	DynamicCustomTypeModelSchema as rawDynamicCustomTypeModelSchema,
	StaticCustomTypeModelTabSchema as rawStaticCustomTypeModelTabSchema,
	DynamicCustomTypeModelTabSchema as rawDynamicCustomTypeModelTabSchema,
} from "./model/customType"
import { DateModelSchema as rawDateModelSchema } from "./model/date"
import { EmbedModelSchema as rawEmbedModelSchema } from "./model/embed"
import { GeoPointModelSchema as rawGeoPointModelSchema } from "./model/geopoint"
import {
	GroupModelSchema as rawGroupModelSchema,
	NestedGroupModelSchema as rawNestedGroupModelSchema,
} from "./model/group"
import { ImageModelSchema as rawImageModelSchema } from "./model/image"
import { IntegrationFieldModelSchema as rawIntegrationFieldModelSchema } from "./model/integrationField"
import { LinkModelSchema as rawLinkModelSchema } from "./model/link"
import { NestableModelSchema as rawNestableModelSchema } from "./model/nestable"
import { NumberModelSchema as rawNumberModelSchema } from "./model/number"
import { RangeModelSchema as rawRangeModelSchema } from "./model/range"
import { RichTextModelSchema as rawRichTextModelSchema } from "./model/richText"
import { SelectModelSchema as rawSelectModelSchema } from "./model/select"
import { SeparatorModelSchema as rawSeparatorModelSchema } from "./model/separator"
import {
	LegacySliceModelSchema as rawLegacySliceModelSchema,
	CompositeSliceModelSchema as rawCompositeSliceModelSchema,
	SharedSliceModelSchema as rawSharedSliceModelSchema,
	SharedSliceModelVariationSchema as rawSharedSliceModelVariationSchema,
	SharedSliceRefModelSchema as rawSharedSliceRefModelSchema,
	StaticSliceModelSchema as rawStaticSliceModelSchema,
	DynamicSliceModelSchema as rawDynamicSliceModelSchema,
	SliceContentModelSchema as rawSliceContentModelSchema,
} from "./model/slice"
import {
	DynamicSlicesModelSchema as rawDynamicSlicesModelSchema,
	StaticSlicesModelSchema as rawStaticSlicesModelSchema,
} from "./model/slices"
import { TableModelSchema as rawTableModelSchema } from "./model/table"
import { TextModelSchema as rawTextModelSchema } from "./model/text"
import { TimestampModelSchema as rawTimestampModelSchema } from "./model/timestamp"
import { UIDModelSchema as rawUIDModelSchema } from "./model/uid"
import {
	StaticWidgetModelSchema as rawStaticWidgetModelSchema,
	DynamicWidgetModelSchema as rawDynamicWidgetModelSchema,
} from "./model/widget"

// Common
export const AssetSchema = toZod4(rawAssetSchema)
export const EmbedSchema = toZod4(rawEmbedSchema)
export const HexaColorCodeSchema = toZod4(rawHexaColorCodeSchema)
export const NonEmptyStringSchema = toZod4(rawNonEmptyStringSchema)
export const WidgetKeySchema = toZod4(rawWidgetKeySchema)

// Content
export const BooleanContentSchema = toZod4(rawBooleanContentSchema)
export const ColorContentSchema = toZod4(rawColorContentSchema)
export const DateContentSchema = toZod4(rawDateContentSchema)
export const EmptyContentSchema = toZod4(rawEmptyContentSchema)
export const GeoPointContentSchema = toZod4(rawGeoPointContentSchema)
export const FilledLinkContentSchema = toZod4(rawFilledLinkContentSchema)
export const EmptyLinkContentSchema = toZod4(rawEmptyLinkContentSchema)
export const LinkContentSchema = toZod4(rawLinkContentSchema)
export const NumberContentSchema = toZod4(rawNumberContentSchema)
export const RangeContentSchema = toZod4(rawRangeContentSchema)
export const SelectContentSchema = toZod4(rawSelectContentSchema)
export const SeparatorContentSchema = toZod4(rawSeparatorContentSchema)
export const SharedSliceContentSchema = toZod4(rawSharedSliceContentSchema)
export const TextContentSchema = toZod4(rawTextContentSchema)
export const TimestampContentSchema = toZod4(rawTimestampContentSchema)
export const FieldContentSchema = toZod4(rawFieldContentSchema)
export const UIDContentSchema = toZod4(rawUIDContentSchema)
export const IntegrationFieldContentSchema = toZod4(rawIntegrationFieldContentSchema)
export const EmbedContentSchema = toZod4(rawEmbedContentSchema)
export const ImageContentViewSchema = toZod4(rawImageContentViewSchema)
export const ImageContentSchema = toZod4(rawImageContentSchema)
export const RichTextContentSchema = toZod4(rawRichTextContentSchema)
export const RichTextContentBlockSchema = toZod4(rawRichTextContentBlockSchema)
export const RichTextContentSpanSchema = toZod4(rawRichTextContentSpanSchema)
export const TableContentSchema = toZod4(rawTableContentSchema)
export const RepeatableContentSchema = toZod4(rawRepeatableContentSchema)
export const NestableContentSchema = toZod4(rawNestableContentSchema)
export const GroupContentSchema = toZod4(rawGroupContentSchema)
export const GroupItemContentSchema = toZod4(rawGroupItemContentSchema)
export const CompositeSliceContentSchema = toZod4(rawCompositeSliceContentSchema)
export const LegacySliceContentSchema = toZod4(rawLegacySliceContentSchema)
export const SliceContentSchema = toZod4(rawSliceContentSchema)
export const LegacySliceItemContentSchema = toZod4(rawLegacySliceItemContentSchema)
export const CompositeSliceItemContentSchema = toZod4(rawCompositeSliceItemContentSchema)
export const SharedSliceItemContentSchema = toZod4(rawSharedSliceItemContentSchema)
export const SliceItemContentSchema = toZod4(rawSliceItemContentSchema)
export const SlicesContentSchema = toZod4(rawSlicesContentSchema)
export const WidgetContentSchema = toZod4(rawWidgetContentSchema)
export const DocumentContentSchema = toZod4(rawDocumentContentSchema)

// Model
export const BooleanModelSchema = toZod4(rawBooleanModelSchema)
export const ColorModelSchema = toZod4(rawColorModelSchema)
export const DateModelSchema = toZod4(rawDateModelSchema)
export const EmbedModelSchema = toZod4(rawEmbedModelSchema)
export const GeoPointModelSchema = toZod4(rawGeoPointModelSchema)
export const ImageModelSchema = toZod4(rawImageModelSchema)
export const IntegrationFieldModelSchema = toZod4(rawIntegrationFieldModelSchema)
export const LinkModelSchema = toZod4(rawLinkModelSchema)
export const NestableModelSchema = toZod4(rawNestableModelSchema)
export const NumberModelSchema = toZod4(rawNumberModelSchema)
export const RangeModelSchema = toZod4(rawRangeModelSchema)
export const RichTextModelSchema = toZod4(rawRichTextModelSchema)
export const SelectModelSchema = toZod4(rawSelectModelSchema)
export const SeparatorModelSchema = toZod4(rawSeparatorModelSchema)
export const SharedSliceModelSchema = toZod4(rawSharedSliceModelSchema)
export const TableModelSchema = toZod4(rawTableModelSchema)
export const TextModelSchema = toZod4(rawTextModelSchema)
export const TimestampModelSchema = toZod4(rawTimestampModelSchema)
export const UIDModelSchema = toZod4(rawUIDModelSchema)
export const GroupModelSchema = toZod4(rawGroupModelSchema)
export const NestedGroupModelSchema = toZod4(rawNestedGroupModelSchema)
export const SharedSliceModelVariationSchema = toZod4(rawSharedSliceModelVariationSchema)
export const SharedSliceRefModelSchema = toZod4(rawSharedSliceRefModelSchema)
export const CompositeSliceModelSchema = toZod4(rawCompositeSliceModelSchema)
export const LegacySliceModelSchema = toZod4(rawLegacySliceModelSchema)
export const DynamicSliceModelSchema = toZod4(rawDynamicSliceModelSchema)
export const StaticSliceModelSchema = toZod4(rawStaticSliceModelSchema)
export const SliceContentModelSchema = toZod4(rawSliceContentModelSchema)
export const DynamicSlicesModelSchema = toZod4(rawDynamicSlicesModelSchema)
export const StaticSlicesModelSchema = toZod4(rawStaticSlicesModelSchema)
export const StaticWidgetModelSchema = toZod4(rawStaticWidgetModelSchema)
export const DynamicWidgetModelSchema = toZod4(rawDynamicWidgetModelSchema)
export const StaticCustomTypeModelTabSchema = toZod4(rawStaticCustomTypeModelTabSchema)
export const DynamicCustomTypeModelTabSchema = toZod4(rawDynamicCustomTypeModelTabSchema)
export const StaticCustomTypeModelSchema = toZod4(rawStaticCustomTypeModelSchema)
export const DynamicCustomTypeModelSchema = toZod4(rawDynamicCustomTypeModelSchema)
/** @deprecated Use DynamicCustomTypeModelSchema instead */
export const CustomTypeModelSchema = DynamicCustomTypeModelSchema

function toZod4<T>(type: T): T {
	return type
}
